// extracted by mini-css-extract-plugin
export default {"m":"BadgeList_m__5L8L3"};